export default "__VITE_ASSET__c9a9b0f5__"